<template>
    <b-row v-if="item" v-bind:class="[{ busy: item.id === busyItemId }, 'cart-overview-item', 'opacity-transition']">
        <pb-spinner v-if="item.id === busyItemId"></pb-spinner>
        <b-col>
            <div v-bind:class="[{ 'border border-danger': item.requestedAmountState === 'RESERVED' },'content py-2']">
                <b-row>
                    <b-col cols="6">
                        <img v-if="thumbnail" class="card-img-top" :src="fileResourceUrl(thumbnail.media)" alt="image"/>
                    </b-col>
                    <b-col cols="6">
                        <b-row class="my-2">
                            <b-col class="article-name">
                                {{item.articleDetails.primaryDescription || item.articleDetails.secondaryDescription}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <small>{{item.articleDetails.name}}</small>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <small>{{customerArticleNumber}}</small>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col>
                        <b-button class="p-0" @click="removeItem({cart: cart, item: item})" variant="link"><i
                                class="fal fa-times fa-inline"></i>
                            REMOVE
                        </b-button>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col>
                        <b-row>
                            <b-col>
                                <b>size: </b>{{selectedSize.value}}
                            </b-col>
                            <b-col>
                                <b>color: </b>{{selectedColor.value}}
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col cols="6">
                        <b-row>
                            <b-col class="m-auto">
                                {{item.totalCalculatedPerUnit | currency($currencyFormatting[articlePrice.currency])}} /
                                {{article.quantityUnit}}
                            </b-col>
                            <b-col>
                                <b>amount: </b>{{item.amount}}
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="6" class="m-auto">
                        {{item.totalCalculated | currency($currencyFormatting[articlePrice.currency])}}

                    </b-col>
                </b-row>
                <b-row class="my-2" v-if="item.requestedAmountState === 'RESERVED'" >
                    <b-col>
                        <small class="text-danger" >
                            {{ $t("warning_amount_reserved") }}
                        </small>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>

<script>

    import CartOverviewItemBase from "./CartOverviewItemBase";

    export default {
        name: 'cart-overview-item-mobile',
        extends: CartOverviewItemBase,
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .cart-overview-item {
        position: relative;
        min-height: 194px;
        margin-bottom: 20px;


        img {
            padding: 20px;
            height: 100%;
            max-height: 194px;
            width: 100%;
            margin: auto;
            object-fit: contain;
        }

        .article-name {
            color: $color-primary-dark;
            font-family: $font-robo;
            font-size: 18px;
            font-weight: 300;
            letter-spacing: 1.5px;
            line-height: 24px;
        }

        .article-options {
            position: absolute;
            bottom: 0;
        }

        .content {
            background-color: #F1F1F1;
            padding: 20px;
            height: 100%;
        }

        .pricing {
            float: right;
            line-height: 34px;
        }
    }
</style>
